import { Component, Inject, LOCALE_ID, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { ProfileService } from "src/app/api/profile.service";
import { Theme } from "src/app/models/theme";
import { LocaleService } from "src/app/services/locale.service";
import { MobileWebViewService } from "src/app/services/mobile-web-view.service";
import { ThemeService } from "src/app/services/theme.service";
import { environment } from "src/environments/environment";

@Component({
    selector: "app-support-page",
    templateUrl: "./support-page.component.html",
    styleUrls: ["./support-page.component.scss"],
    standalone: false
})
export class SupportPageComponent implements OnInit {
  type: string;
  title: string;
  links = environment.links;
  isTypeCopperateOrVipValue: boolean;

  vip = false;

  isMobileWebView$ = this.mobileWebViewService.isMobileWebView$;

  constructor(
    @Inject(LOCALE_ID) private locale: string,
    private route: ActivatedRoute,
    private profileService: ProfileService,
    private localeService: LocaleService,
    private mobileWebViewService: MobileWebViewService,
    private themeService: ThemeService
  ) {
    this.type = this.route.snapshot.paramMap.get("type");
    this.title = this.route.snapshot.queryParamMap.get("title");
  }

  ngOnInit() {
    this.getProfile();
    this.isTypeCopperateOrVipValue = this.isTypeCopperateOrVip();

    if (this.isTypeCopperateOrVip()) {
      this.themeService.set(Theme.Dark);
    }
  }

  getProfile() {
    this.profileService.getGeneral().subscribe((response) => {
      this.vip = response.vip;
    });
  }

  get isAr() {
    return this.locale === "ar";
  }

  isTypeCopperateOrVip() {
    return this.type === "corporateAccount" || this.type === "vipUserSupport";
  }
}
